.soloLabel {
  font-size: var(--font-size-xs);
  color: #6d6d6d;
}
